import React, { FC, useEffect, useState } from "react";
import Link from "next/link";
import { Breadcrumbs, Typography } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import styles from "../../styles/components/_shared/Breadcrumbs.module.scss";
import { useRouter } from "next/router";

const BreadcrumbsComponent: FC<Props> = ({ url, title }) => {
  const router = useRouter();
  const [links, setLinks] = useState<Links[]>([]);

  useEffect(() => {
    // FROM "/our-team/jane-doe" TO ["our-team", "jane-doe"]
    let params = url.split("/");
    params.shift();
    let url_list: Links[] = [];

    // REMOVE queries from last param
    // FROM "communication-skills?counter=100" ====> communication-skills
    let last_param = params[params.length - 1];
    last_param = last_param.split("?").shift();
    params[params.length - 1] = last_param;

    params?.forEach((url, id) => {
      url_list.push({
        // this is needed to add parents params if exist
        to: id > 0 ? `${url_list[id - 1]?.to}/${url}` : url,
        name: url.split("-").join(" "),
      });
      /* created [
        { to: "our-team", name: "our team" },
        { to: "/our-team/jane-doe", name: "jane doe" },
      ] */
    });

    setLinks(url_list);

    return () => {
      setLinks([]);
    };
  }, [url]);

  return (
    <>
      <Breadcrumbs
        separator={<NavigateNext fontSize="small" />}
        className={styles.breadcrumbs}
      >
        <Link href="/" className={`${styles.notActive} ${styles.link}`}>
          Home
        </Link>
        {links?.map((link, id) =>
          id !== links.length - 1 ? (
            <Link
              href={`/${link.to}`}
              key={link.name}
              className={`${styles.notActive} ${styles.link}`}
            >
              {link.name}
            </Link>
          ) : (
            <Typography className={styles.link} key={link.name}>
              {title || link.name}
            </Typography>
          )
        )}
      </Breadcrumbs>
      <hr />
    </>
  );
};

type Links = {
  to: string;
  name: string;
};

interface Props {
  url: string;
  // Optional override for the final (current-page) crumb. When set, it is used
  // verbatim instead of the slug-derived label, so a page can show its real
  // title (e.g. an acronym/brand name) rather than the title-cased URL segment.
  title?: string;
}

export default BreadcrumbsComponent;
